(()=>{'use strict';
 const pad=x=>String(x).padStart(2,'0');
 const toDisplay=s=>/^\d{4}-\d{2}-\d{2}$/.test(s)?s.slice(8,10)+'/'+s.slice(5,7)+'/'+s.slice(0,4):'';
 function toIso(value){
   const match=/^(\d{2})\/(\d{2})\/(\d{4})$/.exec(value.trim());
   if(!match)return '';
   const day=Number(match[1]),mon=Number(match[2]),year=Number(match[3]);
   if(year<1900||year>2100)return '';
   const check=new Date(Date.UTC(year,mon-1,day));
   if(check.getUTCFullYear()!==year||check.getUTCMonth()!==mon-1||check.getUTCDate()!==day)return '';
   return match[3]+'-'+match[2]+'-'+match[1];
 }
 function enhance(date){
   if(date.dataset.pfDateReady)return;
   date.dataset.pfDateReady='1';
   const container=document.createElement('span');container.className='pf-date-shell';
   const text=document.createElement('input');text.type='text';text.className='pf-date-text';text.placeholder='dd/mm/yyyy';
   text.setAttribute('aria-label','dd/mm/yyyy');
   text.autocomplete='off';text.inputMode='numeric';text.maxLength=10;text.pattern='[0-9]{2}/[0-9]{2}/[0-9]{4}';
   text.value=toDisplay(date.value);
   const wasRequired=date.required;date.required=false;text.required=wasRequired;
   const button=document.createElement('button');button.type='button';button.className='pf-date-calendar';
   button.textContent='▦';button.title='Choose date';button.setAttribute('aria-label','Выбрать дату');
   date.parentNode.insertBefore(container,date);container.append(text,button,date);
   date.classList.add('pf-date-native');
   const sync=()=>{
     const iso=toIso(text.value);
     const within=iso&&(!date.min||iso>=date.min)&&(!date.max||iso<=date.max);
     if(within){
       text.setCustomValidity('');
       if(date.value!==iso){date.value=iso;date.dispatchEvent(new Event('input',{bubbles:true}));date.dispatchEvent(new Event('change',{bubbles:true}))}
     }else{
       if(date.value){date.value='';date.dispatchEvent(new Event('change',{bubbles:true}))}
       text.setCustomValidity(text.value.trim()? 'Use dd/mm/yyyy and a valid date':'');
     }
   };
   text.addEventListener('input',sync);
   text.addEventListener('blur',()=>{if(date.value)text.value=toDisplay(date.value)});
   date.addEventListener('change',()=>{if(date.value)text.value=toDisplay(date.value)});
   button.addEventListener('click',()=>{
     try{date.showPicker?.()}catch{date.focus();date.click()}
   });
   const form=date.closest('form');
   if(form)form.addEventListener('reset',()=>setTimeout(()=>{text.value=toDisplay(date.value);text.setCustomValidity('')},0));
 }
 function init(){document.querySelectorAll('input[type="date"]').forEach(enhance)}
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
 document.addEventListener('click',event=>{
   const el=event.target instanceof Element?event.target.closest('a[href]'):null;
   const theme=new URLSearchParams(location.search).get('preview_theme_id');
   if(!el||!theme||!/^\d+$/.test(theme))return;
   let url;try{url=new URL(el.href,location.href)}catch{return}
   if(url.origin!==location.origin)return;
   if(!url.pathname.includes('/pages/pawfect-')&&!url.pathname.endsWith('/')&&!url.hash.startsWith('#pawfect-food-match'))return;
   url.searchParams.set('preview_theme_id',theme);
   el.href=url.toString();
 },true);
})();